import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { Observable } from 'rxjs';
import {
  MainTableColumn,
  MainTableColumnId,
} from '@prlw/core/monitor/types/main-table';
import { MainTableService } from '../table/main-table/main-table.service';

@Component({
  selector: 'prlw-table-manage-overlay',
  templateUrl: './manage-overlay.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageOverlayContainer {
  @Output() public readonly closeOverlay = new EventEmitter<void>();
  public columns$: Observable<MainTableColumn<MainTableColumnId>[]>;

  constructor(private readonly mainTableService: MainTableService) {
    this.columns$ = mainTableService.columns$;
  }

  public close(): void {
    this.closeOverlay.emit();
  }

  public toggleColumnVisible(columnId: MainTableColumnId): void {
    this.mainTableService.toggleColumnVisible(columnId);
  }
}
